import { contextlessInstanceOf } from "./Polyfill/instanceOf";

/**
 * Znaci, ze do metody byl predan neplatny argument. Je mozne specifikovat argument, u ktereho doslo k vyjimce.
 */
export class InvalidArgumentException extends Error {
    constructor(argument: string | null = null) {
        super(`Invalid argument${argument ? ` (${argument})` : ""}`); //`
    }

    public static override get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && contextlessInstanceOf(instance, InvalidArgumentException);
    }
}

export class InvalidOperationException extends Error {
    public static override get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && contextlessInstanceOf(instance, InvalidOperationException);
    }
}

export class NotImplementedException extends Error {
    constructor() {
        super("Not implemented");
    }

    public static override get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && contextlessInstanceOf(instance, NotImplementedException);
    }
}

export class UserAbortedException extends Error {
    constructor() {
        super("User aborted operation");
    }

    public static override get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && contextlessInstanceOf(instance, UserAbortedException);
    }
}

/** Vyvolána v případě, že se nepovedlo načíst data z důvodu padavé chyby */
export class DataSourceException extends Error {
    /** DataSource je filtrován */
    public readonly isFiltered: boolean;

    constructor(isFiltered?: boolean) {
        super("Unable to load data");

        this.isFiltered = isFiltered ? isFiltered : false;
    }

    public static override get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && contextlessInstanceOf(instance, DataSourceException);
    }
}

/** Vyvolána v případě nevalidní podmínky pro filtr/dataReader */
export class InvalidConditionException extends Error {
    /** Nevalidní části podmínky */
    public readonly invalidValues: ReadonlyArray<IInvalidConditionValue>;

    constructor(invalidValues?: ReadonlyArray<IInvalidConditionValue>) {
        super("Invalid condition");

        this.invalidValues = invalidValues ? invalidValues : [];
    }

    public static override get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && contextlessInstanceOf(instance, InvalidConditionException);
    }
}

/** Nevalidní hodnota/atribut v podmínce */
export interface IInvalidConditionValue {
    /** Atribut, který neprošel validací */
    readonly attributeName: string;
    /** Typ problému */
    readonly errorType: ConditionErrorType;
}

/** Podporované typy chyb při validaci podmínky */
export enum ConditionErrorType {
    invalidAttributeName,
    forbiddenDataType,
}
